module.exports = __webpack_public_path__ + "img/fire_tool_3.146fb1df.png";